import { zodResolver } from '@hookform/resolvers/zod';
import { Modal } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { ChangeAliasRequest } from '@/module/Dashboard/model/DashboardTypes';

import { Form, TextInputControl } from '@/core/components';

interface AliasAddFormProps {
  onClose: () => void;
  isSubmitting: boolean;

  onChange: (request: ChangeAliasRequest) => void;
}

export const aliasAddSchema = z.object({
  alias: z.string().trim().min(3),
});

type AliasAddSchema = z.infer<typeof aliasAddSchema>;

export function AliasAddForm(props: AliasAddFormProps) {
  const { onClose, isSubmitting, onChange } = props;
  const { t } = useTranslation();
  const form = useForm<AliasAddSchema>({
    defaultValues: { alias: '' },
    resolver: zodResolver(aliasAddSchema),
  });

  return (
    <Modal
      opened
      onClose={onClose}
      title={t('profile.addAlias')}
    >
      <FormProvider {...form}>
        <Form
          onSubmit={form.handleSubmit(onChange)}
          onCancel={onClose}
          title=""
          isSubmitting={isSubmitting}
        >
          <TextInputControl<AliasAddSchema>
            label={t('profile.alias.title')}
            name="alias"
            description={t('profile.alias.description')}
            isSubmitting={isSubmitting}
          />
        </Form>
      </FormProvider>
    </Modal>
  );
}
